/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { object, string, bool } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import NUpDesktop from './Desktop/NUpDesktop';
import NUpMobile from './Mobile/NUpMobile';
import uniqueId from '../../../helpers/contentstack/uniqueId';
import { getIsBot } from '../../../../state/ducks/App/App-Selectors';

const useStyles = makeStyles((theme) => ({
    block: (stylesObj) => ({
        position: 'relative',
        margin: '0 auto 20px',
        [theme.breakpoints.down(1024)]: {
            margin: '0 auto 16px',
        },
        backgroundColor: stylesObj?.background_color?.color || 'transparent',
    }),
}));

const NUpRow = ({
    data, headingAlignment, headingAlignmentMobile, fixedMessage,
}) => {
    // GB42-1352
    const isBot = useSelector(getIsBot);
    const dataUniqueId = uniqueId(data.reference[0].unique_selector);
    const cmsuid = data.reference[0].uid || null;
    const { display_on = 'Both' } = data.reference[0];
    const isMobile = display_on === 'Mobile' || display_on === 'Both';
    const isDesktop = display_on === 'Desktop' || display_on === 'Both';

    const classes = useStyles();

    if (data?.reference[0]?.unique_selector) {
        if (data.reference[0]?._content_type_uid === 'n_up') {
            return (
                <>
                    <div className={`nup_block ${classes.block}`} data-uniqueid={dataUniqueId} cmsuid={cmsuid}>
                        <DesktopMobile
                            desktop={() => {
                                if (!isDesktop) return null;
                                return <NUpDesktop data={data} headingAlignment={headingAlignment} fixedMessage={fixedMessage} isBot={isBot} />;
                            }}
                            mobile={() => {
                                if (!isMobile) return null;
                                return <NUpMobile data={data} headingAlignment={headingAlignmentMobile} fixedMessage={fixedMessage} isBot={isBot} />;
                            }}
                            breakpoint={700}
                        />
                    </div>
                </>
            );
        }
    }
    return <></>;
};

NUpRow.defaultProps = {
    headingAlignment: 'center',
    headingAlignmentMobile: 'center',
    fixedMessage: false,
};

NUpRow.propTypes = {
    data: object.isRequired,
    headingAlignment: string,
    headingAlignmentMobile: string,
    fixedMessage: bool,
};

export default (NUpRow);
